/* eslint-disable */
export default {
      "bumblesite@join_hives.app_store_button": 0,
      "bumblesite@join_hives.bullet_1.header": 1,
      "bumblesite@join_hives.bullet_1.text": 2,
      "bumblesite@join_hives.bullet_2.header": 3,
      "bumblesite@join_hives.bullet_2.text": 4,
      "bumblesite@join_hives.bullet_3.header": 5,
      "bumblesite@join_hives.bullet_3.text": 6,
      "bumblesite@join_hives.get_started_cta": 7,
      "bumblesite@join_hives.link_preview.body": 8,
      "bumblesite@join_hives.link_preview.header": 9,
      "bumblesite@join_hives.page_header": 10,
      "bumblesite@join_hives.page_subcopy": 11,
      "bumblesite@join_hives.play_store_button": 12,
      "bumblesite@LAYOUT.FOOTER.MANAGE_COOKIES": 13,
      "bumblesite@team_bumble.page_index.footer.links.gender_gap": 14,
      "bumblesite@team_bumble.page_index.footer.links.slavery": 15,
      "bumblesite@team_bumble.page_index.footer.links.terms": 16,
      "bumblesite@team_bumble.page_index.navigation.links.about": 17,
      "bumblesite@team_bumble.page_index.navigation.links.life": 18
} as const;
